import { Alert, Backdrop, BottomNavigation, BottomNavigationAction, Box, Button, CircularProgress, Container, Paper, Stack, TextareaAutosize, Typography } from "@mui/material";
import { LogementPageOutletContext, ViewKind } from "../../LogementPageBase"
import { Navigate, useNavigate, useOutletContext } from "react-router";
import { useState } from "react";
import { useConfirm } from "material-ui-confirm";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { useApiService } from "../../../../contexts/ApiServiceContext";
import { Logger } from '../../../../utils/Logger';
import { trackUserFlow } from "../../../../services/AppInsightsPlugin";

export interface SaveTabContent {
    readonly viewKind: ViewKind;
}

export const SaveTabContent = (_props: SaveTabContent) => {
    const { deleteLogement, upsertLogement, isCurrentUserHanditoit } = useApiService();
    const { logementAccessor, currentLogement } = useOutletContext() as LogementPageOutletContext;
    const [busy, setBusy] = useState(false);
    const [navigateTo, setNavigateTo] = useState<string | undefined>(undefined);
    const [error, setError] = useState<string | undefined>(undefined);
    const confirm = useConfirm();
    const handleDelete = async () => {
        if (!currentLogement) {
            return;
        }
        confirm({
            cancellationText: "Non",
            confirmationText: "Oui",
            title: "Suppression",
            description: "Etes vous sur de vouloir supprimer ce logement ?"
        }).then(async () => {
            setError(undefined);
            setBusy(true);
            try {
                await deleteLogement(currentLogement.id, new AbortController().signal);
                trackUserFlow('LOGEMENT_DELETE_SUCCESS', {
                    logementId: currentLogement.id
                });
                setNavigateTo("/");
            } catch (err) {
                Logger.error('SaveTab', 'Delete failed', err);
                const errorMsg = err instanceof Error ? err.message : 'Unknown error';
                trackUserFlow('LOGEMENT_DELETE_FAILED', {
                    logementId: currentLogement.id,
                    errorMessage: errorMsg
                });
                setError("La suppression a échoué. Veuillez réessayer.");
            } finally {
                setBusy(false);
            }
        }).catch(() => {
            // canceled
        });
    };
    const handleCancel = () => {
        if (!currentLogement) {
            return;
        }
        trackUserFlow('LOGEMENT_EDIT_CANCELLED', {
            logementId: currentLogement.id,
            tabName: 'save'
        });
        setNavigateTo("/");
    };
    const handleSave = async () => {
        if (!currentLogement) {
            return;
        }
        setError(undefined);
        setBusy(true);
        try {
            const result = await upsertLogement(currentLogement, new AbortController().signal);
            const id = result?.logement?.id ?? currentLogement.id;
            trackUserFlow('LOGEMENT_SAVE_SUCCESS', {
                logementId: id,
                isNew: currentLogement.id === 0
            });
            setNavigateTo(`/logement/${id}/view/historique`);
        } catch (err) {
            Logger.error('SaveTab', 'Save failed', err);
            const errorMsg = err instanceof Error ? err.message : 'Unknown error';
            trackUserFlow('LOGEMENT_SAVE_FAILED', {
                logementId: currentLogement.id,
                errorMessage: errorMsg
            });
            setError("L'enregistrement a échoué. Veuillez réessayer.");
        } finally {
            setBusy(false);
        }
    };
      const navigate = useNavigate();
      const goToPrevious = () => {
          navigate("../documents");
      };
    return (<Box sx={{ pb: 7 }}>
        <Backdrop
            sx={{
                color: (theme) => theme.palette.background.default,
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
            open={busy}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        {navigateTo !== undefined && <Navigate to={navigateTo}/>}
        {navigateTo === undefined && <Stack sx={{mb: 1}}>
            <Typography component="h3" variant="subtitle2" sx={{mt: 1, mb: 1}}>
                Commentaire d'historique
            </Typography>
            <Box>
                <TextareaAutosize
                    minRows={7}
                    value={logementAccessor.comment?.get() ?? ""}
                    onChange={(ev) => logementAccessor.comment?.set(ev.target.value)}
                    style={{width: "100%", resize: "none"}}
                />
            </Box>
            {error && <Alert severity="error" sx={{mt: 1, mb: 1}}>{error}</Alert>}
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{mt: 1, mb: 1}}>
                <Button variant="outlined" onClick={handleCancel}>Annuler</Button>
                <Button variant="outlined" onClick={handleSave}>Enregistrer</Button>
            </Stack>
            {currentLogement && currentLogement.id !== 0 && isCurrentUserHanditoit() && <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{mt: 1, mb: 1}}>
                <Button variant="outlined" color="error" onClick={handleDelete}>Supprimer le logement</Button>
            </Stack>}
        </Stack>}
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
            <Container sx={{p: "1 1"}} maxWidth="md">
                <BottomNavigation
                showLabels
                >
                    <BottomNavigationAction label="Précédent" icon={<NavigateBefore />} onClick={goToPrevious} />
                    <BottomNavigationAction label="Suivant" icon={<NavigateNext />} sx={{visibility: "hidden"}} />
                </BottomNavigation>
            </Container>
        </Paper>
    </Box>);
}
